module.exports = __webpack_public_path__ + "static/media/TAMUni-Tamil150.9fe397ca.ttf";